import { I18nGenericData } from 'src/app/i18n';
import { SessionTypeEnum } from './event-types';

export enum ParticipantRoleEnum {
  AGENT = 'AGENT',
  // PROSPECT = 'PROSPECT',
  // CANDIDATE = 'CANDIDATE',
  // ANONYMOUS = 'ANONYMOUS',
}

export enum ParticipantContactEnum {
  MOBILE_EMAIL = 'MOBILE_EMAIL',
  MOBILE = 'MOBILE',
  EMAIL = 'EMAIL',
}

export enum CreatedViaEnum {
  FORM = 'FORM',
  INPUT = 'INPUT',
}

export enum AttendanceStatusEnum {
  NOT_ATTENDED = 'NOT_ATTENDED',
  ATTENDED = 'ATTENDED',
  CANCELLED = 'CANCELLED',
}

export enum RegistrationTypeEnum {
  RSVP = 'RSVP',
  WALKIN = 'WALKIN',
}

export type ParticipantOverview = {
  eventId: string;
  quota?: string;
  registered: string;
  attended?: string;
  attendanceRate?: string;
  walkin?: string;
  sessions: SessionOverview[];
};

export type SessionOverview = {
  _id: string;
  key: string;
  type: SessionTypeEnum;
  name: I18nGenericData<string>;
  quota: string;
  registered: string;
  attended: string;
  attendanceRate: string;
  walkin?: string;
};

export type ParticipantItem = {
  registrationId: string;
  firstName: string;
  lastName: string;
  role: ParticipantRoleEnum;
  referer: string;
  agentCode?: string;
  contact: ParticipantContactEnum;
  registrationTime: Date;
  qrCode: string;
  createdFrom: CreatedViaEnum;
  createdBy: string;
  lastUpdatedBy: string;
  createdAt: Date;
  updatedAt: Date;
  attendanceStatus?: AttendanceStatusEnum;
};

export type ParticipantDetailItem = Omit<ParticipantItem, 'attendanceStatus'> & {
  phoneNumber?: string;
  email?: string;
  isAttended: boolean;
  checkInAt?: Date;
  checkOutAt?: Date;
  duration?: string;
  sessions?: ParticipantSessionItem[];
};

export type ParticipantSessionItem = {
  key: string;
  name: I18nGenericData<string>;
  startTime: Date;
  endTime: Date;
  isRegistered: boolean;
  isAttended: boolean;
  attendeeId?: string;
  checkInAt?: Date;
  checkOutAt?: Date;
  duration?: string;
  subSessions?: ParticipantSessionItem[];
};

export type AttendancePageState = {
  open: boolean;
  participantDetail?: ParticipantDetailItem;
};

export type RemoveDialogState = {
  open: boolean;
  id?: string;
};
